import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import { getlocalstorage } from './../../../constants/local_storage'

import * as actions from './actions'
import moment from 'moment'

function* loadSeparateVehicleStatus(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem('profile'),
    'company_id',
  )

  const {
    data: {
      list_vehicle_id,
      vehicle_status_id,
      vehicle_type_id,
      eventdate,
      type_file,
    },
  } = action.payload
  const date_start = moment(eventdate[0]['_d']).format('YYYY-MM-DD 00:00:00')
  const date_end = moment(eventdate[1]['_d']).format('YYYY-MM-DD 23:59:59')
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_API_REPORT_GOLANG}/reports/go/separatevehiclestatus`,
      // `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/separatevehiclestatus`,
      {
        date_start,
        date_end,
        list_vehicle_id,
        company_id: COMPANY_ID,
        vehicle_type_id: `${vehicle_type_id}`,
        vehicle_status: vehicle_status_id,
        type_file,
      },
      {
        headers: { Authorization: `Bearer ${ACCESSTOKEN}` },
        onDownloadProgress: progressEvent => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          ) // you can use this to show user percentage of file downloaded
        },
      },
    )
    yield put(actions.loadSeparateVehicleStatus.success(res.data))
    window.location = res.data.result
  } catch (err) {
    yield put(actions.loadSeparateVehicleStatus.failure())
  }
}

function* loadSeparateVehicleStatuspreview(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')

  const {
    data: {
      list_vehicle_id,
      vehicle_status,
      vehicle_type_id,
      date_start,
      date_end,
      type_file,
      company_id,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_API_REPORT_GOLANG}/reports/go/separatevehiclestatus`,
      {
        date_start,
        date_end,
        list_vehicle_id,
        company_id,
        vehicle_type_id,
        vehicle_status,
        type_file,
      },
      {
        headers: { Authorization: `Bearer ${ACCESSTOKEN}` },
        onDownloadProgress: progressEvent => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          )
        },
      },
    )
    yield put(actions.loadSeparateVehicleStatuspreview.success(res.data))
    window.location = res.data.result
  } catch (err) {
    yield put(actions.loadSeparateVehicleStatuspreview.failure())
  }
}

function* loadVehicle(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem('profile'),
    'company_id',
  )

  const vehicle_visibility = getlocalstorage(
    localStorage.getItem('profile'),
    'vehicle_visibility',
  )

  const { vehicletypeID } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getvehiclebygroupid`,
      {
        companyID: COMPANY_ID,
        vehicletypeID: vehicletypeID,
        allow_vehicles: vehicle_visibility,
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )
    yield put(actions.loadVehicle.success(res.data))
  } catch (err) {
    yield put(actions.loadVehicle.failure())
  }
}

function* loadVehicleType(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem('profile'),
    'company_id',
  )

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getgroupvehicle`,
      {
        company_id: COMPANY_ID,
      },
      {
        headers: { Authorization: `Bearer ${ACCESSTOKEN}` },
      },
    )
    yield put(actions.loadVehicleType.success(res.data))
  } catch (err) {
    yield put(actions.loadVehicleType.failure())
  }
}

export default function* watchReportPoolState() {
  yield all([
    takeEvery(
      actions.LOAD_SEPARATEVEHICLESTATUS.REQUEST,
      loadSeparateVehicleStatus,
    ),
    takeEvery(
      actions.LOAD_SEPARATEVEHICLESTATUS_PREVIEW.REQUEST,
      loadSeparateVehicleStatuspreview,
    ),
    takeEvery(actions.LOAD_VEHICLE_SEPARATEVEHICLESTATUS.REQUEST, loadVehicle),
    takeEvery(
      actions.LOAD_VEHICLE_TYPE_SEPARATEVEHICLESTATUS.REQUEST,
      loadVehicleType,
    ),
  ])
}

export {
  loadSeparateVehicleStatus,
  loadVehicle,
  loadVehicleType,
  loadSeparateVehicleStatuspreview,
}
